import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';

import { DateTemplate } from '../../../../components/dateTemplate/DateTemplate';
import { monthNames } from '../../../../utils/typeConstants';
import { RecalculationJobLogs } from '../recalculationJobLogs/RecalculationJobLogs';
import './RecalculationRequestLog.scss'

export const RecalculationRequestLog = (props: any) => {
    const [showLogsDialog, setShowLogsDialog] = React.useState(false);
    const [calculationRequestId, setCalculationRequestId] = React.useState(0);
    const performancePeriod = (rowData: any) => {
        const month = rowData?.month;
        const year = rowData?.year;
        // Format the date as "mon-yyyy"
        const formattedDate = `${monthNames[Number(month)]} ${year}`;
        return <span className="image-text">{formattedDate}</span>;
    };

    const statusTimeTemplate = (rowData: any) => {
        const date = new Date(rowData?.log_date);
        if (isNaN(date.getTime())) return ''; // Check if date is valid

        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';

        hours = hours % 12 || 12; // Convert hour 0 to 12 for 12-hour clock format
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes; // Ensure two-digit minutes

        return `${hours}:${formattedMinutes} ${ampm}`;
    };
    const onScorecardClick = (event: any) => {
        if (event.field === 'scorecard_name') {
            setShowLogsDialog(true);
            setCalculationRequestId(event.rowData.calculation_request_id);
        }
    };
    const closeLogsDialog = (message: boolean) => {
        setShowLogsDialog(!message);
        setCalculationRequestId(0);
    };

    const employeTemplate = (rowData: any) => {
        return <span className="image-text">{rowData?.employee ? rowData?.employee : '--'}</span>;
    };

    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={props?.recalculationRequest?.data}
                    dataKey="calculation_request_id"
                    scrollHeight="600px" scrollable 
                    paginator={props?.recalculationRequest?.data?.length > 5}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    rows={5} id="RecalculationReqTable"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    sortField="log_date"
                    sortOrder={-1}
                    onCellClick={onScorecardClick} cellSelection selectionMode="single"
                >
                    <Column
                        header="Scorecard"
                        field="scorecard_name"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem',color: 'blue',textDecoration: 'underline'}}
                        sortable
                        sortField="scorecard_name"
                    />
                    <Column
                        header="Performance Period"
                        headerStyle={{ minWidth: '7rem' }}
                        bodyStyle={{ minWidth: '7rem' }}
                        body={performancePeriod}
                    />
                    <Column
                        header="Status"
                        field="calculation_request_status_name"
                        headerStyle={{ minWidth: '7rem' }}
                        bodyStyle={{ minWidth: '7rem' }}
                        sortable
                        sortField="calculation_request_status_name"
                    />
                    <Column
                        header="Status Time"
                        headerStyle={{ minWidth: '5rem' }}
                        bodyStyle={{ minWidth: '5rem' }}
                        body={statusTimeTemplate}
                    />
                    <Column
                        header="Status Date"
                        field="log_date"
                        sortable
                        sortField="log_date"
                        style={{ minWidth: '8rem' }}
                        body={(date) => DateTemplate(date?.log_date)}
                    />
                    <Column
                        header="Type"
                        field="calculation_request_type_name"
                        headerStyle={{ minWidth: '8rem' }}
                        bodyStyle={{ minWidth: '8rem' }}
                        sortable
                        sortField="calculation_request_type_name"
                    />
                    <Column
                        header="Employee"
                        field="employee"
                        headerStyle={{ minWidth: '10rem' }}
                        bodyStyle={{ minWidth: '10rem' }}
                        sortable
                        sortField="employee"
                        body={employeTemplate}
                    />
                    <Column
                        header="Requestor"
                        field="requestor"
                        sortable
                        sortField="requestor"
                        style={{ minWidth: '10rem' }}
                    />
                </DataTable>
                {showLogsDialog &&
                <RecalculationJobLogs
                    showLogsDialog={showLogsDialog}
                    closeLogsDialog={closeLogsDialog}
                    requestId={calculationRequestId}
                    />}
            </div>
        </div>
    );
};
